import { DescriptionRounded, FolderRounded, ImageRounded } from "@mui/icons-material";
import { green, orange, red } from "@mui/material/colors";

export const archiveTreeEndpoint = "/api/studio/shoot_archive/tree";
export const archiveDownloadEndpoint = "/api/studio/shoot_archive/download";
export const archiveJobsEndpoint = "/api/studio/shoot_archive/active_jobs";
export const jobsPollingTime = 5000;
export const rootArchivePath = "Shoot/shootSkuImages";

export const itemTypes = {
	folder: "folder",
	image: "image",
	file: "file",
};

export const jobStatusColor = {
	queued: orange[700],
	processing: orange[700],
	completed: green[700],
	failed: red[700],
};

export const normalizeArchiveNode = (node = {}) => {
	const rawType = String(node.type || node.nodeType || itemTypes.file).toLowerCase();
	const type = rawType === "directory" ? itemTypes.folder : rawType;
	return {
		name: node.name || node.label || node.fileName || node.path?.split("/").pop() || "Untitled",
		type,
		path: node.path || node.filePath || "",
		url: node.url || node.publicUrl || "",
		children: Array.isArray(node.children) ? node.children : [],
	};
};

export const getNodeIcon = (node) => {
	if (node.type === itemTypes.folder) return <FolderRounded />;
	if (node.type === itemTypes.image) return <ImageRounded />;
	return <DescriptionRounded />;
};

export const downloadByUrl = (url, filename, anchorRef) => {
	if (anchorRef?.current) {
		anchorRef.current.href = url;
		anchorRef.current.download = filename;
		anchorRef.current.click();
	} else {
		window.open(url, "_blank", "noopener,noreferrer");
	}
};
